import Image from "@Components/Image";
import styles from "./PartnerReferHomeSection.module.scss";
import HomeTickIcon from "@Icons/HomeTickIcon";
import Button from "@Components/Button";
import ArrowRightIcon from "@Icons/ArrowRightIcon";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import { BASE_IMG_URL } from "constants/configConstants";
import PartnerLeadFormModal from "@Components/PartnerLeadFormModal";
import LeadFormDispatcher from "@Components/PartnerLeadFormModal/actions";
import { useDispatch } from "react-redux";
import wrapperHOC from "@Utils/wrapperHOC";
import ScholarshipBanner from "../ScholarshipBanner";
import useWhitelabel from "hooks/useWhitelabel";
import useTranslationHook from "hooks/useTranslationHook";

interface PartnerReferHomeSectionProps {
  isDesktop?: boolean;
  data: any;
}

const PartnerReferHomeSection: React.FC<PartnerReferHomeSectionProps> = ({
  isDesktop = false,
  data,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslationHook();
  const { isUSAPartner } = useWhitelabel();

  const handleEnquire = () => {
    const leadFormDispatcher = new LeadFormDispatcher(dispatch);
    leadFormDispatcher.handleOnEnquireClick({
      data: {},
      source: "partner_enquire",
      page: 1,
    });
  };

  return data.id ? (
    <div className={formatClassNames(styles.sectionReferredContainer, isDesktop && styles.desktop)}>
      <div
        className={formatClassNames(styles.sectionInnerContainer, isDesktop && styles.desktop)}
        style={{ backgroundImage: `url("${BASE_IMG_URL}home-partners-refer-banner.svg")` }}
      >
        <div className={formatClassNames(styles.sections, isDesktop && styles.desktop)}>
          <span className={isDesktop && styles.desktop}>Referred by</span>
          <div
            className={formatClassNames(
              styles.referrerDetailsContainer,
              isDesktop && styles.desktop,
            )}
          >
            <div className={styles.imageContainer}>
              {data.partner_images.length > 0 ? (
                <Image src={`${data.partner_images[0].path}`} width={107} height={113} />
              ) : (
                <Image src={`${BASE_IMG_URL}circle-user-dark.svg`} width={40} height={40} />
              )}
            </div>
            <div className={styles.referrerDetails}>
              <div
                className={formatClassNames(styles.partnerHeader, isDesktop ? styles.desktop : "")}
              >
                <div className={styles.heading}>{data.name}</div>
                <div className={styles.subHeading}>
                  {t("home.partnerrefersection.ambertrustedpartner")}
                </div>
              </div>
              {data.partner_description[0] && (
                <div
                  className={formatClassNames(styles.description, isDesktop && styles.desktop)}
                  dangerouslySetInnerHTML={{ __html: data.partner_description[0].value }}
                />
              )}
            </div>
          </div>
        </div>
        <div className={styles.sections}>
          <HomeTickIcon tickFill="#e26575" homeFill="#ec919c" />
          <div className={formatClassNames(styles.bannerText, isDesktop && styles.desktop)}>
            Start finding the perfect {isUSAPartner ? "apartment" : "accommodation"} now!
          </div>
          <Button
            variant="primary"
            RightIcon={ArrowRightIcon}
            labelStyles={styles.buttonLabelStyles}
            className={formatClassNames(styles.button, isDesktop && styles.desktop)}
            onClick={handleEnquire}
          >
            {isUSAPartner ? "Get Personalized Assistance" : "Get Personalised Assistance"}
          </Button>
        </div>
      </div>
      <PartnerLeadFormModal partnerData={data && data} />
      <ScholarshipBanner isMobile={!isDesktop} />
    </div>
  ) : (
    <></>
  );
};

export default wrapperHOC(PartnerReferHomeSection, {
  componentName: "PartnerReferHomeSection-Home",
  showForChina: true,
});
